import { render } from "./ToggleAlt.vue?vue&type=template&id=550817cf&scoped=true"
import script from "./ToggleAlt.vue?vue&type=script&lang=js"
export * from "./ToggleAlt.vue?vue&type=script&lang=js"

import "./ToggleAlt.vue?vue&type=style&index=0&id=550817cf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550817cf"]])

export default __exports__